$(function () {
  const $grid = $(".masonry-wrapper").masonry({
    itemSelector: ".item",
    columnWidth: ".item",
    percentPosition: true,
    transitionDuration: 0,
  });

  $grid.imagesLoaded().progress(function () {
    $grid.masonry();
  });
});

$("#nav_bar").each(function () {
  const $navBar = $(this);
  const navPos = $navBar.offset()!.top;

  // on scroll
  $(window).on("scroll", function () {
    // get scroll position from top of the page
    var scrollPos = $(this).scrollTop()!!;

    // check if scroll position is >= the nav position
    if (scrollPos >= navPos) {
      $navBar.addClass("navbar-fixed");
    } else {
      $navBar.removeClass("navbar-fixed");
    }
  });

  $(document).on("ready", function () {
    $(".cross").hide();
    $(".menu").hide();
    $(".hamburger").on("click", function () {
      $(".menu").slideToggle("slow", function () {
        $(".hamburger").hide();
        $(".cross").show();
      });
    });

    $(".cross").on("click", function () {
      $(".menu").slideToggle("slow", function () {
        $(".cross").hide();
        $(".hamburger").show();
      });
    });
  });
});
